import { render } from "./ResubscribeModal.vue?vue&type=template&id=567452e1&scoped=true"
import script from "./ResubscribeModal.vue?vue&type=script&lang=js"
export * from "./ResubscribeModal.vue?vue&type=script&lang=js"

import "./ResubscribeModal.vue?vue&type=style&index=0&id=567452e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567452e1"]])

export default __exports__